const state = {
  _id: localStorage.getItem('_id'),
  accessToken: localStorage.getItem('access_token'),
  // authenticated: false,
  authenticated: !!localStorage.getItem('access_token'),
  checked: false,
  error: '',
  errorOnOnboard: undefined,
  errors: {},
  expiresAt: localStorage.getItem('expires_at'),
  idToken: localStorage.getItem('id_token'),
  isOnboardPending: false,
  onboard: null,
  profile: {},
  registered: {},
  token: null,
  user: {}
}

export default state
